import React from 'react';

const CarbonFfootprint = () => {
  return (
    <div className="key-statics">
      <div className="first-title">
        <h5>59 million mt</h5>
        <p>Carbon footprint (FY2019: 58 million mt)</p>
      </div>
      <h5>29%</h5>
      <p>Water recycling rate (FY2019: 28%)</p>
    </div>
  );
};

export default CarbonFfootprint;
